export default class NumberViewModel {
    name: string;
    value: number;

    public constructor(name: string, value: number) {
        this.name = name;
        this.value = value;
    }
}